// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Lrc5","notes":"Notes_notes__3bxxB","note":"Notes_note__1GrFj","markdown":"Notes_markdown__3kGt_"};